export default "__VITE_ASSET__BjRNSotn__"